<template>
    <div class="time-grid-week" :class="{'eventDragged': eventDragged.eventId}" ref="container">
        <div class="header-days">
            <div class="day" v-for="(day, index) in dayLabels" :key="day">
                <label class="day-label">{{ day }} {{ weekDayNumbers[index] }}</label>
                <div class="count-event" :class="{'no-content': !countEvent[index]}">{{countEvent[index]}}</div>
            </div>
        </div>
        <div class="grid">
            <div class="scrollable-area">
                <div 
                    class="time-slot" 
                    v-for="(hour, hourIndex) in 24" :key="hour"
                    v-if="true || eventsByTime.some(day => day[hourIndex].length > 0)"
                    ref="timeSlot"
                >
                    <div class="time-label">{{ String(hourIndex).padStart(2, '0') }} h</div>
                    <div 
                        v-for="(dayNumber, dayIndex) in 7" 
                        class="cell-day" 
                        :id="`cell-${dayIndex}-${hourIndex}`"
                        :key="dayNumber" 
                        :class="{
                            'today': datePassedInfo.dayIndex === dayIndex,
                            'passed': datePassedInfo.dayIndex > dayIndex ||
                                (
                                    datePassedInfo.dayIndex == dayIndex &&  
                                    (
                                        datePassedInfo.hourIndex > hourIndex
                                    )
                                )
                        }"
                        @click.stop="(e) => selectDate(e,dayIndex+'-'+hourIndex+'-0')"
                    >
                        <div 
                            class="slot" 
                            v-for="(slotNumber, index) in 6" 
                            @click.stop="(e) => selectDate(e,dayIndex+'-'+hourIndex+'-'+index)"
                            :key="dayNumber+'-'+hourIndex+'-'+index" 
                            :class="{empty: eventsByTime[dayIndex][hourIndex].length == 0}"
                            :drag-event-magnetic="
                                datePassedInfo.dayIndex < dayIndex ||
                                (
                                    datePassedInfo.dayIndex == dayIndex &&  
                                    (
                                        datePassedInfo.hourIndex < hourIndex ||
                                        (datePassedInfo.hourIndex == hourIndex && datePassedInfo.slotIndex < index)
                                    )
                                )
                            "
                            :data-drag-event-hours="hourIndex"
                            :data-drag-event-minutes="index*10"
                            :data-drag-event-location="`${dayIndex}-${hourIndex}-${index}`"
                        >
                            <template v-if="eventsByTime[dayIndex][hourIndex].length >= slotNumber">
                                <div 
                                    v-if="slotNumber == 6 && eventsByTime[dayIndex][hourIndex].length > 6" 
                                    class="container-btn-more"
                                >
                                    <div                     
                                        class="btn-more"
                                        @click.stop="showMoreEvents(dayIndex, hourIndex)"
                                    >
                                        {{ $t('dash.posts.planner.more-events', { count: eventsByTime[dayIndex][hourIndex].length - 5 }) }}
                                    </div>
                                </div>
                                <Event 
                                    v-else
                                    :key="eventsByTime[dayIndex][hourIndex][index].id"
                                    v-bind="eventsByTime[dayIndex][hourIndex][index]"
                                    :isPlaceholder="eventDragged.eventId === eventsByTime[dayIndex][hourIndex][index].id"
                                    :isDraggable="eventsByTime[dayIndex][hourIndex][index].editable !== false"
                                    @eventDragStart="eventDragStart"
                                    @eventClick="$emit('eventClick', eventsByTime[dayIndex][hourIndex][index].id)"
                                />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="btn-stacked-mode btn-radius" @click="$emit('changeView', 'dayGridWeek')">
            <i class="fa-solid fa-angles-up"></i>
            {{ $t('dash.posts.planner.collapse') }}
        </div>

        <EventsPopUp
            v-if="popUpOptions.dayKey && popUpOptions.hourKey"
            @close="closeMoreEvents"
            @eventDragStart="eventDragStart"
            @eventClick="(id) => $emit('eventClick', id)"
            :eventDragged="eventDragged"
            :events="eventsByTime[popUpOptions.dayKey][popUpOptions.hourKey]"
            :containerRef="$refs.container"
            :anchorRef="popUpOptions.anchorRef"
            :title="popUpOptions.dateLabel"

        />

        <DraggableEvent 
            v-bind="eventDragged"
            @eventDragStop="eventDragStop"
        />
    </div>
</template>

<script>
    import Event from '../Event.vue'
    import DraggableEvent from '../DraggableEvent.vue';
    import EventsPopUp from '../EventsPopUp.vue';

    export default {
        components: {
            Event,
            DraggableEvent,
            EventsPopUp
        },
        props: {
            currentDate: {
                type: String,
                default: ()=> new Date().toISOString()
            },
            events: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                popUpOptions: {
                    dayKey: null,
                    hourKey: null,
                    anchorRef: null,
                    dateLabel: null,
                    position: { top: 0, left: 0}
                },

                eventDragged: {
                    e:null,
                    el:null,
                    eventId: null,
                    event: null
                },
                scrollInterval: null,
                scrollSpeed: 0,
                scrollThreshold: 60,
                rafId: null,
                scrollVelocity: 0,
                countEvent: Array.from({ length: 7 }, () => 0)
            }
        },
        methods: {
            selectDate(e, dateKey) {
                if (e.target.closest('.container-event')) {
                    return;
                }
                const [dayIndex, hourIndex, slotIndex] = dateKey.split('-').map(num => parseInt(num));
                let timestamp = this.getCurrentStart().getTime();
                timestamp += dayIndex * 24 * 60 * 60 * 1000; // jours
                timestamp += hourIndex * 60 * 60 * 1000; // heures
                timestamp += slotIndex * 10 * 60 * 1000; // minutes
                const newDate = new Date(timestamp);
                this.$emit('selectDate', newDate.toISOString());
            },

            showMoreEvents(dayIndex, hourIndex) {

                const anchorRef = document.getElementById( `cell-${dayIndex}-${hourIndex}`)
                console.log('showMoreEvents', anchorRef, dayIndex, hourIndex);
                if (!anchorRef) return
              

                // const date = new Date(dateString);

                // const dateLabel = new Intl.DateTimeFormat('fr-FR', {
                //     day: 'numeric',
                //     month: 'long',
                //     year: 'numeric'
                // }).format(date);
                
                this.popUpOptions.anchorRef = anchorRef;
                this.popUpOptions.dayKey = dayIndex;
                this.popUpOptions.hourKey = hourIndex;
                this.popUpOptions.dateLabel = this.$t('dash.posts.planner.events-between', {
                    start: String(hourIndex).padStart(2, '0'),
                    end: String(hourIndex + 1).padStart(2, '0')
                });
            },


            closeMoreEvents() {
                this.popUpOptions.dayKey = null;
                this.popUpOptions.hourKey = null;
                this.popUpOptions.anchorRef = null;
                this.popUpOptions.dateLabel = null;
            },

              eventDragStart({ e, eventId, el }) {
                this.$emit('eventDragStart', { eventId });
                const event = this.events.find(ev => ev.id === eventId);
                window.addEventListener('mousemove', this.handleAutoScroll);
                this.stopAnimation()
                this.eventDragged = {
                    e,
                    eventId,
                    el,
                    event: {...event}
                };
            },

            eventDragStop({ location_id }) {
                window.removeEventListener('mousemove', this.handleAutoScroll);
                this.stopAnimation();

                const event = this.eventDragged.event
                console.log('eventDragStop location_id', location_id);

                if (location_id) {
                    const [dayIndex, hourIndex, slotIndex] = location_id.split('-').map(num => parseInt(num));
                    let timestamp = this.getCurrentStart().getTime();
                    timestamp += dayIndex * 24 * 60 * 60 * 1000; // jours
                    timestamp += hourIndex * 60 * 60 * 1000; // heures
                    timestamp += slotIndex * 10 * 60 * 1000; // minutes

                    const newDate = new Date(timestamp);
                    event.dateInstance = newDate;
                    event.date = newDate.toISOString();
                }

                const index = this.events.findIndex(ev => ev.id ===  event.id);

                if (index !== -1) {
                    this.$set(this.events, index, event);
                }else{
                    this.$set(this.events, this.events.length, {...event});
                }

                this.$emit('eventDragStop', { 
                    event: {...event}
                });

                this.eventDragged = {
                    e:null,
                    eventId: null,
                    event: null
                };
            },

            handleAutoScroll(e) {
                const scrollContainer = this.$el.querySelector('.scrollable-area');
                const rect = scrollContainer.getBoundingClientRect();
                
                const threshold = 80; // Zone de détection plus large pour plus de souplesse
                const maxSpeed = 15;  // Vitesse max en pixels par frame
                
                const distTop = e.clientY - rect.top;
                const distBottom = rect.bottom - e.clientY;

                let speed = 0;

                if (distTop < threshold) {
                    // Courbe d'accélération : plus on est proche du bord, plus c'est rapide
                    speed = -Math.pow((threshold - distTop) / threshold, 2) * maxSpeed;
                } else if (distBottom < threshold) {
                    speed = Math.pow((threshold - distBottom) / threshold, 2) * maxSpeed;
                }

                this.scrollVelocity = speed;

                if (this.scrollVelocity !== 0 && !this.rafId) {
                    this.startAnimation();
                } else if (this.scrollVelocity === 0) {
                    this.stopAnimation();
                }
            },

            startAnimation() {
                const scrollContainer = this.$el.querySelector('.scrollable-area');
                
                const step = () => {
                    if (this.scrollVelocity !== 0) {
                        scrollContainer.scrollTop += this.scrollVelocity;
                        this.rafId = requestAnimationFrame(step);
                    } else {
                        this.stopAnimation();
                    }
                };
                
                this.rafId = requestAnimationFrame(step);
            },

            stopAnimation() {
                if (this.rafId) {
                    cancelAnimationFrame(this.rafId);
                    this.rafId = null;
                }
            },

            //api
            prev() {
                const now = this.getCurrentStart();
                now.setDate(now.getDate() - 7);
                this.$emit('gotoDate', now.toISOString());
                this.closeMoreEvents();
            },

            next() {    
                const now = this.getCurrentEnd();
                this.$emit('gotoDate', now.toISOString());
                this.closeMoreEvents();
            },
            getCurrentStart() {
                const date = new Date(this.currentDate);
                const dayIndex = date.getDay(); // 0 = dimanche, 1 = lundi, ..., 6 = samedi
                const diff = dayIndex === 0 ? -6 : 1 - dayIndex; 
                date.setDate(date.getDate() + diff);
                date.setHours(0, 0, 0, 0); // Réinitialiser à minuit
                return date;
            },

            getCurrentEnd() {
                const date = this.getCurrentStart();
                date.setDate(date.getDate() + 7);
                return date
            },

            scrollToFirstEvent() {
                this.$nextTick(() => {
                    const indexFistHours = this.eventsByTime.map((hoursArray) => {
                        return hoursArray.findIndex(hourEvents => hourEvents.length > 0);
                    }).filter(index => index !== -1);
                    const firstHourIndex = Math.min(...indexFistHours);
                    if (firstHourIndex !== Infinity && this.$refs.timeSlot[firstHourIndex]) {
                        this.$refs.timeSlot[firstHourIndex].scrollIntoView({ behavior: "smooth" });
                    }else{
                        this.$refs.timeSlot[6].scrollIntoView({ behavior: "smooth" });
                    }
                    
                });
            },
            scrollToTime(hours){
                if (this.$refs.timeSlot[hours]) {
                    this.$refs.timeSlot[hours].scrollIntoView({ behavior: "smooth" });
                }
            }

          
        },
        computed: {
            dayLabels() {
                const locale = this.$i18n.locale || 'fr-FR';
                const monday = new Date(2024, 0, 1);
                return Array.from({ length: 7 }, (_, i) => {
                    const d = new Date(monday);
                    d.setDate(monday.getDate() + i);
                    return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(d);
                });
            },
            eventsByTime() {
                //create empty 7x24 array
                const tab = Array.from({ length: 7 }, () =>  Array.from({ length: 24 }, () => [])); 
                const countEvent = Array.from({ length: 7 }, () => 0);

                const startWeekTime = this.getCurrentStart().getTime();
                const endWeekTime = this.getCurrentEnd().getTime();

                this.events.forEach(event => {
                    event.dateInstance = new Date(event.date);
                    const timestamp = event.dateInstance.getTime();

                    if (timestamp >= startWeekTime && timestamp < endWeekTime) {
                        let dayIndex = event.dateInstance.getDay();
                        dayIndex = dayIndex === 0 ? 6 : dayIndex - 1; // ajuster pour que lundi = 0
                        tab[dayIndex][event.dateInstance.getHours()].push(event);
                        countEvent[dayIndex]++;
                    }
                });
                this.countEvent = countEvent;

                return tab;
                
            },
                   
            datePassedInfo() {
                const dateInfo = {
                    dayIndex: -1,
                    hourIndex: -1,
                    slotIndex: -1
                };

                const timestamp = Date.now();

                const startWeekTime = this.getCurrentStart().getTime();
                const endWeekTime = this.getCurrentEnd().getTime();

                //la date d'aujourd'hui est dans les semaine precedentes
                if (startWeekTime >= timestamp) {
                    return dateInfo;
                }

                //la date d'aujourd'hui est dans les semaine suivantes
                if (timestamp > endWeekTime) {
                    dateInfo.dayIndex = 7;
                    dateInfo.hourIndex = 24;
                    dateInfo.slotIndex = 6;
                    return dateInfo;
                }

                //la date d'aujourd'hui est dans la semaine affichée
                const currentDate = new Date(timestamp);
                let dayIndex = currentDate.getDay();
                dayIndex = dayIndex === 0 ? 6 : dayIndex - 1;
                dateInfo.dayIndex = dayIndex;
                dateInfo.hourIndex = currentDate.getHours();
                dateInfo.slotIndex = Math.floor(currentDate.getMinutes() / 10);
                return dateInfo;
            },

            weekDayNumbers() {
                const start = this.getCurrentStart();
                return Array.from({ length: 7 }, (_, i) => {
                    const d = new Date(start);
                    d.setDate(d.getDate() + i);
                    return d.getDate();
                });
            }
        },

        destroyed () {
            window.removeEventListener('mousemove', this.handleAutoScroll);
            this.stopAnimation()
        },
    }
</script>